var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "CommuterTrain",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-commuter-train","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M67.3 156.8c-1.5 1.5-2.2 3.5-2.2 5.5s.7 4 2.2 5.5c1.5 1.5 3.5 2.2 5.5 2.2s4-.7 5.5-2.2c1.5-1.5 2.2-3.5 2.2-5.5s-.7-4-2.2-5.5c-2.8-3-8-3-11 0z"/>
  <path d="M172.7 156.8c-1.5 1.5-2.2 3.5-2.2 5.5s.7 4 2.5 5.5c1.5 1.5 3.5 2.2 5.5 2.2s4-.7 5.5-2.2c1.5-1.5 2.2-3.5 2.2-5.5s-.7-4-2.2-5.5c-3.3-3-8.5-3-11.3 0z"/>
  <path d="M226.9 176.2V46.4c0-22.4-19.1-38.3-36.8-38.3h-49.2c-1-4.5-5-8-9.4-8h-14.9c-4.5 0-8.2 3.5-9.4 8H60.9C38.5 8.1 23.4 24 23.4 46.4v129.8c0 14.2 12.4 32.3 31.3 35.8l-30.8 30.6c-1 1-1 2.7 0 4l1.5 1.5c1 1 2.7 1 4 0l35.5-35.5h120.3l35.5 35.5c1 1 2.7 1 4 0l1.5-1.5c1-1 1-2.7 0-4l-31.1-30.3c17.7-2.5 31.8-17.5 31.8-36.1zm-36.8 28.3h-2.7c-.7-.2-1.5-.2-2.2 0H64.3c-.7-.2-1.5-.2-2.2 0h-1.2c-13.7 0-29.8-14.9-29.8-28.6V46.4c0-19.1 13.4-30.6 29.8-30.6h47c1.5 3.5 5 6 8.7 6h14.9c3.7 0 7.2-2.5 8.7-6h50.2c13.7 0 29.1 16.9 29.1 30.6v129.8c-.3 13.4-15.7 28.3-29.4 28.3z"/>
  <path d="M169.7 35.7H81.5c-16.7 0-30.1 13.4-30.1 30.1v52.9c0 4.2 3.5 7.2 7.7 7.2h132.7c4.2 0 7.7-3 7.7-7.2V65.8c.3-16.6-13.3-30.1-29.8-30.1zm21.7 81.6H59.9V65.8c0-8 9.9-20.9 17.9-20.9H173c8 0 18.4 12.9 18.4 20.9v51.5z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/commuter-train.svg